const splitAt = index => x => [x.slice(0, index), x.slice(index)];

const flatten = (arr) => {
  return arr.reduce((acc, val) => Array.isArray(val) ? acc.concat(flatten(val)) : acc.concat(val), []);
};

const splitUntilAllPartsAreLessThan = len => x => {
  const a = splitAt(len)(x);
  a[1] = a[1].length > len
    ? splitUntilAllPartsAreLessThan(len)(a[1])
    : a[1];
  return a;
};

const formatText = (word) => {
  const arr = splitUntilAllPartsAreLessThan(20)(word);
  return flatten(arr).join('\n');
};

const prepareText = (preparedText, word) => {
  return preparedText.length > 0
    ? `${preparedText} ${formatText(word)}`
    : formatText(word);
};

const splitOnSpace = (text) => text.replace(/\n/g, '\n ').split(' ');

const maybeInsertSpace = (preparedText, word) => {
  return preparedText.length > 0
    ? (() => {
      return preparedText.slice(-1) === '\n'
        ? `${preparedText}${word}`
        : `${preparedText} ${word}`;
    })()
    : word;
};

/**
 * manaully split any string greater than `len` characters
 * with a new line before we send it to be typeset.
 * we're trying to emulate the browser's `word-break: break-all;`
 * functionality without breaking typesetting.
 */
export const emulateWordBreakAt = (len) => (text) => {
  return splitOnSpace(text).reduce((preparedText, word) => {
    return word.length > len
      ? prepareText(preparedText, word)
      : maybeInsertSpace(preparedText, word);
  }, '');
};

const extraSupportedCharacters = [8211, 8212, 8216, 8217, 8218, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8249, 8250, 8260, 8364, 8482, 8722, 64257, 64258];

export const isUnsupportedCharacter = (char) => {
  const codePoint = char.codePointAt(0);

  if (extraSupportedCharacters.includes(codePoint)) {
    return false;
  }

  return (codePoint >= 256);
};

export const stripSpecialCharacters = (text) => {
  const { specialCharacters, cleanedText } = [...text].reduce((acc, char) => {
    const specChar = isUnsupportedCharacter(char) ? char : null;

    if (specChar) {
      acc.specialCharacters = acc.specialCharacters.concat([specChar])
    } else {
      acc.cleanedText += char;
    }

    return acc;
  }, { specialCharacters: [], cleanedText: '' });

  const errorMessage = specialCharacters.length
    ? `The following chars can not be printed and will be removed: ${specialCharacters.join(' ')}`
    : null;

  return { cleanedText, specialCharacters,  errorMessage, originalText: text };
};

export const capitalize = (str) => {
  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
}
